<template>
  <div class="box3">
   <img src="../../../assets/coursePage/trainer/03.png"/>
  </div>
</template>

<script>


export default {
 
  data() {
    return {
 
    };
  },
};
</script>

<style lang="less" scoped>
.box3 {
  width: 100%;
 img{
  width: 100%;
  display: block;
 }
  
}
</style>
